import { render, staticRenderFns } from "./ModalAyudas.vue?vue&type=template&id=048bcfb8&scoped=true&"
import script from "./ModalAyudas.vue?vue&type=script&lang=js&"
export * from "./ModalAyudas.vue?vue&type=script&lang=js&"
import style0 from "./ModalAyudas.vue?vue&type=style&index=0&id=048bcfb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048bcfb8",
  null
  
)

export default component.exports